export default __webpack_public_path__ + "static/media/bg_leistungen.d67de90d.webp";